@if (gradient && !imgJpeg) {
  <div class="project-color"
    [style.background]="trustedStyle('linear-gradient(to bottom right, '+gradient.start+', '+gradient.end+')')"
    [ngClass]="{'is-small':size==='small', 'no-corner': removeCorner}">
    @if (maxAlertLevel > 0) {
      <div
        [ngClass]="maxAlertLevel >= 2000 ? 'color-warning-red' : 'color-warning-yellow'"
        [matTooltip]="alertToolTip"
        matTooltipPosition="above"
        matTooltipClass="multiline-tooltip-wide">
        <span class="warning-text">{{'dashboard.attention' | translate}}</span>
      </div>
    }
  </div>
}
@if (imgJpeg) {
  <div class="project-color">
    <img class="project-img" alt="No Image" [ngClass]="{'is-small':size==='small', 'no-corner': removeCorner}" src="{{'data:image/jpg;base64,' + imgJpeg}}"/>
    @if (maxAlertLevel > 0) {
      <div
        [ngClass]="maxAlertLevel >= 2000 ? 'color-warning-red' : 'color-warning-yellow'"
        [matTooltip]="alertToolTip"
        matTooltipPosition="above"
        matTooltipClass="multiline-tooltip-wide">
        <span class="warning-text">{{'dashboard.attention' | translate}}</span>
      </div>
    }
  </div>
}
